module.exports = "/images/earring.svg?f60d79f2f76ac25d941948e2c8fa3b56";